import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaUF = (): TabelaColuna => ({
  Chave: 'uf',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 90 }}>UF</div>
})
